import { countries, delocaliseUri } from 'lib/locale';
import { getOrigin } from 'lib/util';

const stores = Object.entries(countries).map(([k, c]) => [
  k,
  c.store.replace('-store', ''),
]);

export default function Alternates({ pathname }: { pathname: string }) {
  return (
    <>
      <link
        rel="alternate"
        hrefLang="x-default"
        href={`${getOrigin()}/us/en${delocaliseUri(pathname)}`}
      />
      <link
        rel="alternate"
        hrefLang="en"
        href={`${getOrigin()}/us/en${delocaliseUri(pathname)}`}
      />
      {stores.map(([country, store]) => {
        return (
          <link
            key={country}
            rel="alternate"
            hrefLang={`en-${country.toUpperCase()}`}
            href={`${getOrigin()}/${store}/en${delocaliseUri(pathname)}`}
          />
        );
      })}
    </>
  );
}
